<template>
  <div>


    <!-- Pannello scommessa in accettazione / accettata / rifiutata -->
    <BetInAcceptanceInCart></BetInAcceptanceInCart>

    <!-- Empty state: solo senza odds, senza scommessa confermata e senza scommessa in accettazione -->
    <div class="empty-betslip" v-if="getBet.odds.length == 0 && !getConfirmedBet && !hasAcceptanceBets">
      <div class="empty-state__card">
        <span class="empty-state__sub">{{ $t('noOddsSelectedHint') }}</span>


      </div>
    </div>

    <!-- Contenuto normale betslip: nascosto quando la scommessa è confermata o in accettazione -->
    <div v-if="!getConfirmedBet && !hasAcceptanceBets && getBet.odds.length > 0">
      <BetTypeSelectorTerminal></BetTypeSelectorTerminal>
      <BetOddsSummaryTerminal></BetOddsSummaryTerminal>

      <v-progress-linear
          indeterminate
          color="var(--color-primary)"
          v-if="getLoading"
      ></v-progress-linear>

      <div v-if="getBet.type == 'single' || getBet.type == 'multiple'">
        <SummarySingleMultipleTerminal></SummarySingleMultipleTerminal>
      </div>
      <div v-else-if="getBet.type == 'integral'">
        <SummaryIntegralTerminal></SummaryIntegralTerminal>
      </div>
      <div v-else-if="getBet.type == 'system'">
        <SummarySystemTerminal></SummarySystemTerminal>
      </div>
    </div>

    <Errors></Errors>
    <Warnings></Warnings>

    <!-- Pannello riepilogo scommessa confermata -->
    <BetConfirmedTerminal></BetConfirmedTerminal>


  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import BetTypeSelectorTerminal from "@/components/terminal/BetTypeSelectorTerminal";
import BetOddsSummaryTerminal from "@/components/terminal/BetOddsSummaryTerminal";
import SummarySingleMultipleTerminal from "@/components/terminal/SummarySingleMultipleTerminal";
import SummaryIntegralTerminal from "@/components/terminal/SummaryIntegralTerminal";
import SummarySystemTerminal from "@/components/terminal/SummarySystemTerminal";
import ActionsMarketView from "@/components/right_widgets/ActionsMarketView";
import Errors from "@/components/right_widgets/Errors";
import Warnings from "@/components/right_widgets/Warnings";
import BetConfirmedTerminal from "@/components/terminal/BetConfirmedTerminal";
import BetInAcceptanceInCart from "@/components/right_widgets/BetInAcceptanceInCart";

export default {
  name: 'BetSlip',
  components: {
    Warnings, SummarySingleMultipleTerminal, SummaryIntegralTerminal, SummarySystemTerminal,
    ActionsMarketView, Errors, BetOddsSummaryTerminal, BetTypeSelectorTerminal,
    BetConfirmedTerminal, BetInAcceptanceInCart,
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters({
      'getLanguage':    'settings/getLanguage',
      'getBet':         'cart/getBet',
      'getSettings':    'cart/getSettings',
      'getLoading':     'cart/getLoading',
      'getMobileCartOpen': 'cart/getMobileCartOpen',
      'getConfirmedBet':            'cart/getConfirmedBet',
      'getAcceptingBets':           'cart/getAcceptingBets',
      'getAcceptedBetWithChange':   'cart/getAcceptedBetWithChange',
    }),

    // Hide the regular betslip while a bet is pending operator review or operator proposed a change
    hasAcceptanceBets() {
      return (this.getAcceptingBets || []).length > 0 || (this.getAcceptedBetWithChange || []).length > 0;
    },

  },
  methods: {
    ...mapActions({
      'setLoadingCart': 'cart/setLoadingCart',
      'refreshCart': 'cart/refreshCart',
      'initCartV2': 'cart/initCartV2',
      'setBetType': 'cart/setBetType',
      'setSystemComboDetail': 'cart/setSystemComboDetail',
    }),

  },
  async mounted() {
    this.getBet.system_parts = []
    this.getBet._system_detail.amount_system_to_divide = null
    this.getBet._system_detail.amount_system_equal = null
    this.getBet._system_detail.amount_system = 0.00
    this.getBet._system_detail.fixed_bases = []
    // await this.refreshCart()
    await this.initCartV2()
  },

};
</script>

<style scoped>
/* ── Empty state ─────────────────────────────────────────── */
.empty-betslip {
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px 20px;
  width: 100%;
  border-radius: 12px;
  text-align: center;
  animation: fadeInUp 0.4s ease;
}

.empty-state__icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(255,255,255,0.07);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-op-50-platform);
  flex-shrink: 0;
}

.empty-state__title {
  font-size: var(--font-size-6xl);
  font-weight: 600;
  color: var(--text-platform);
}

.empty-state__sub {
  font-size: var(--font-size-xl);
  color: var(--text-op-50-platform);
  line-height: 1.4;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bsl-hint{
  font-size: var(--font-size-3xl);
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}


.live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-primary);
  box-shadow: 0 0 0 4px rgba(5, 149, 114, 0.15);
  animation: pulse 1.8s infinite;
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(5, 149, 114, 0.4); }
  50%       { box-shadow: 0 0 0 6px rgba(5, 149, 114, 0); }
}

</style>